import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export const useScrollIntoViewByAnchor = (id: string) => {
  const ref = useRef<HTMLElement | null>(null);

  const anchor = useRouterState({ select: state => state.location.hash });

  useEffect(() => {
    const element = ref.current;

    if (element && anchor === id) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [anchor, id]);

  return ref;
};
